import React from 'react';

/**
 * ProductCardSkeleton Component
 * Smooth shimmer skeleton placeholder matching the ProductCard layout
 */
export default function ProductCardSkeleton() {
  return (
    <div className="flex flex-col justify-between bg-white dark:bg-[#18181C] border border-neutral-200/80 dark:border-white/10 rounded-2xl p-2.5 sm:p-3 shadow-sm relative overflow-hidden">
      {/* Aspect Square Image Placeholder with Shimmer */}
      <div className="relative aspect-square w-full rounded-xl overflow-hidden bg-neutral-200 dark:bg-[#1e1e1e] border border-neutral-200/50 dark:border-white/[0.08] animate-shimmer" />

      {/* Content Placeholders */}
      <div className="flex-1 flex flex-col justify-between mt-2.5 space-y-2">
        <div className="space-y-1.5">
          {/* Rating placeholder */}
          <div className="h-2.5 w-12 rounded bg-neutral-200 dark:bg-[#282830] animate-shimmer" />
          {/* Title placeholder lines */}
          <div className="h-3.5 w-full rounded bg-neutral-200 dark:bg-[#282830] animate-shimmer" />
          <div className="h-3.5 w-3/4 rounded bg-neutral-200 dark:bg-[#282830] animate-shimmer" />
        </div>

        {/* Pricing & Button Placeholder */}
        <div className="flex items-end justify-between pt-2 border-t border-neutral-100 dark:border-white/[0.06]">
          <div className="space-y-1">
            <div className="h-2.5 w-10 rounded bg-neutral-200 dark:bg-[#282830] animate-shimmer" />
            <div className="h-4 w-16 rounded bg-neutral-200 dark:bg-[#282830] animate-shimmer" />
          </div>
          <div className="w-7 h-7 rounded-full bg-neutral-200 dark:bg-[#282830] shrink-0 animate-shimmer" />
        </div>
      </div>
    </div>
  );
}

